import { render } from "./hzbas.vue?vue&type=template&id=073ae5ff&scoped=true&ts=true"
import script from "./hzbas.vue?vue&type=script&lang=ts"
export * from "./hzbas.vue?vue&type=script&lang=ts"

import "./hzbas.vue?vue&type=style&index=0&id=073ae5ff&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-073ae5ff"]])

export default __exports__